export default {
  state: {
    products: {},
    bundleType: '1',
    bundleList: [],
    imageList: [],
    variantsList: [],
    currentVariant: null,
    isEdit: false
  },
  mutations: {
    setProducts(state, data) {
      state.products = data;
    },
    setBundleType(state, data) {
      state.bundleType = data;
    },
    setBundleList(state, data) {
      state.bundleList = data;
    },
    setImageList(state, data) {
      state.imageList = data;
    },
    setVariantsList(state, data) {
      state.variantsList = data;
    },
    setCurrentVariant(state, data) {
      state.currentVariant = data;
    },
    setIsEdit(state, data) {
      state.isEdit = data;
    }
  },
  actions: {}
};
